import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { Web2BannerComponent } from './web2-banner.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [
    Web2BannerComponent,
  ],
  exports: [
    Web2BannerComponent,
  ],
})
export class Web2BannerModule { }
